import { render, staticRenderFns } from "./freedom.vue?vue&type=template&id=5063fd4c&scoped=true"
import script from "./freedom.vue?vue&type=script&lang=js"
export * from "./freedom.vue?vue&type=script&lang=js"
import style0 from "./freedom.vue?vue&type=style&index=0&id=5063fd4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5063fd4c",
  null
  
)

export default component.exports